module.exports = __webpack_public_path__ + "img/au.9b18ee04.svg";